import axios from 'axios';
import { Staff, CreateStaffRequest } from '../types/Staff';

const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getStaff = async (token: string): Promise<Staff[]> => {
  try {
    const response = await api.get('/staff', {
      headers: {
        Authorization: token,
      },
    });
    return response.data.staff || [];
  } catch (error: any) {
    console.error('Error fetching staff:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch staff');
  }
};

export const getStaffMember = async (token: string, email: string): Promise<Staff> => {
  try {
    const response = await api.get(`/staff/${encodeURIComponent(email)}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error('Error fetching staff member:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch staff member');
  }
};

export const createStaff = async (token: string, staff: CreateStaffRequest): Promise<Staff> => {
  try {
    const response = await api.post('/staff', staff, {
      headers: {
        Authorization: token,
      },
    });
    return response.data.staff;
  } catch (error: any) {
    console.error('Error creating staff:', error);
    throw new Error(error.response?.data?.error || 'Failed to create staff');
  }
};

export const updateStaff = async (
  token: string,
  email: string,
  updates: Partial<Staff>
): Promise<Staff> => {
  try {
    const response = await api.put(`/staff/${encodeURIComponent(email)}`, updates, {
      headers: {
        Authorization: token,
      },
    });
    return response.data.staff;
  } catch (error: any) {
    console.error('Error updating staff:', error);
    throw new Error(error.response?.data?.error || 'Failed to update staff');
  }
};

export const deleteStaff = async (token: string, email: string): Promise<void> => {
  try {
    await api.delete(`/staff/${encodeURIComponent(email)}`, {
      headers: {
        Authorization: token,
      },
    });
  } catch (error: any) {
    console.error('Error deleting staff:', error);
    throw new Error(error.response?.data?.error || 'Failed to delete staff');
  }
};
